export enum processList {
    count = "count",
    getData = "getData",
}

export enum ProductEnum {
    id = "Product Id",
    ean = "EAN13/GTIN",
    title = "Product Name",
    type = "Cannabis Soort",
    thumbnailUrl = "Thumbnail",
    description = "Cannabis Soort",
    thc = "THC Gehalte",
    cbd = "CBD Gehalte",
    rating = "Score",
    images = "Afbeeldingen",
    terpenes = "Terpenen",
}

export enum ShopEnum {
    id = "Shop Id",
    title = "Cannabis Shop",
    lat = "Latitude",
    lng = "Longitude",
    rating = "Score",
}